import * as React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { brand } from '../../theme';

/**
 * Two-option segmented control (left = false, right = true).
 * Replaces the old styled Switch, which was re-created on every render (it lost focus and
 * its animation) and was hard to understand on touch screens.
 */
export default function SwitchComponent({ checked, handleSwitchSelected, disabled, labelLeft, labelRight, fullWidth = true, size = 'medium' }) {
  const handleChange = (event, value) => {
    if (value === null || value === undefined) return; // keep one option selected
    handleSwitchSelected(value === 'right');
  };

  return (
    <ToggleButtonGroup
      exclusive
      fullWidth={fullWidth}
      size={size}
      value={checked ? 'right' : 'left'}
      onChange={handleChange}
      disabled={Boolean(disabled)}
      sx={{
        p: 0.5,
        gap: 0.5,
        borderRadius: '14px',
        backgroundColor: '#EEF0F6',
        '& .MuiToggleButtonGroup-grouped': {
          border: 0,
          borderRadius: '10px !important',
          fontWeight: 700,
          textTransform: 'none',
          color: brand.slate,
          minHeight: size === 'small' ? 36 : 42,
          '&.Mui-selected': {
            color: brand.primary,
            backgroundColor: '#FFFFFF',
            boxShadow: `0 4px 12px -4px ${alpha(brand.ink, 0.18)}`,
            '&:hover': { backgroundColor: '#FFFFFF' },
          },
        },
      }}
    >
      <ToggleButton value="left">{labelLeft}</ToggleButton>
      <ToggleButton value="right">{labelRight}</ToggleButton>
    </ToggleButtonGroup>
  );
}
